import React,{ Component } from "react";
import { InputField } from "../../common/custom-form/input-filter-component";
import DATEPICKER_OR from "../../common/custom-form/custom-date-picker.component";
import { TabberButton } from "../../common/custom-form/tabber-button.component";
import ButtonIcon from "../../button"
import { InputGroup, FormControl, Button } from "react-bootstrap";
import Icons from '../../icon';
import { DataTable } from "../../common/table/data-table/data-table-component";
import LineItem from "./invoice-line-item";
import ManageInvoiceLayout from "../../common/report/reports/Invoice/manage-invoice/manage-invoice-layout.component";
import InvoiceComment from "../../common/report/reports/Invoice/manage-invoice/invoice-comment.component";
import  InvoiceHistory from "../../common/report/reports/Invoice/manage-invoice/invoice-history.component";
import { SelectField } from "../../common/custom-form/select-filter.component";
import { Selected_Index } from "../../../constants/internal-constants";
export default class InternalManageInvoice extends Component{
    constructor(props){
        super(props);
        this.getDataSelected=this.getDataSelected.bind(this);
        this.state={
            selectFilter:[
                {
                    "FilterId":5,
                    "FilterName":"Account Number",
                    "FilterType":"Textbox",
                    "Page":"CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                },
                {
                    "FilterId":4,
                    "FilterName":"Circuit ID",
                    "FilterType":"Textbox","Page":
                    "CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                },
                {
                    "FilterId":7,
                    "FilterName":"Circuit Status",
                    "FilterType":"Textbox",
                    "Page":"CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                }
               ],
            filterSelected: "", 
            inputValue: "",
            invoiceDate: "",
            invoiceApproveDate: "",
            invoiceDueDate: "",
            billingPeriodDate: "",
            invoiceExpectedDate: "",
            rentalPeriodDate: "",
            actualInvoiceMonth: "",
            invoiceReceiptDate: "",
            beginDate: "",
            endDate: "",
            dataTable:[
                {              
                    HeaderItem:[
                        {
                            name:"Contract Name"
                        },
                        {
                            name:"Vendor"
                        }, {
                            name:"Status"
                        }
                    ],
                    dataItem:[{            
                        columnItem1:"3G Hutchison (GB) Contract",
                        columnItem2: "3G Hutchison (GB)",
                        columnItem3: "Expired"                       
                    }, {            
                        columnItem1:"3G Hutchison (GB) Contract",
                        columnItem2: "3G Hutchison (GB)",
                        columnItem3: "Expired"
                    },{            
                        columnItem1:"3G Hutchison (GB) Contract",
                        columnItem2: "3G Hutchison (GB)",
                        columnItem3: "Expired"
                    }        
                    ]
    
                }
            ],
            selectedIndex:"0", 
            dataSelected:0,
            tableSelected:false,
            listTabInfo:{
                Tab:[
                    {
                        "id":"0",
                        "label":"Details"            
                    },
                    {
                        "id":"1",
                        "label":"History"           
                    },
                    {
                        "id":"2",
                        "label":"Comments"           
                    }
                ]
            },
            dataInfo:[
                {
                    "name " : "Johny Deep",
                    "date " : "June 08, 2021",
                    "time" : "4:00 PM",
                     "comment" :[
                         "Update-Circuit ID: 0",
                         "Order Submit Date: From: May 31, 2021 at 4:00PM TO: June 07, 2021 at 4:00 AM",
                         "Order Circuit Required Date: From: TO: June  07, 2021 at 4:00PM"
                     ]
                }
            ],
            commentData:[
                {
                    "name " : "Johny Deep",
                    "date " : "June 08, 2021",
                    "time" : "4:00 PM",
                     "comment" :[
                         "Update-Circuit ID: 0"                         
                     ]
                },
                {
                    "name " : "Johny Deep",
                    "date " : "June 08, 2021",
                    "time" : "4:00 PM",
                     "comment" :[                         
                         "Order Circuit Required Date: From: TO: June  07, 2021 at 4:00PM"
                     ]
                }
            ],

        }
    }

    getDataSelected(data) {
        this.setState({selectedIndex:data})
       
    }

    openLineItem(data) {
        this.setState({tableSelected:data})
    }

    render(){   
        const {selectFilter,dataInfo,startDate,dataTable,listTabInfo,tableSelected,selectedIndex}=this.state;           
        return(

            <ManageInvoiceLayout onGetSelected={this.getDataSelected.bind(this)} closeForm={this.props.closeForm} listData={listTabInfo.Tab} haveHeaderButton={true}>

                {
                    selectedIndex===Selected_Index.i_Zero &&

                            <div className="manage-invoice-container">
                            <div className="manage-invoice-detail">
                                <SelectField label="ACCOUNT NUMBER"  options={selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>                                
                                <InputField label="SUB ACCOUNT NUMBER" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="PROVIDER" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <SelectField label="CURRENCY"  options={selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>                                
                                <SelectField label="ASSINED USER"  options={selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>                                                       
                                <InputField label="CREATION DATE" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="EXCHANGE RATE" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <SelectField label="PLEASE SELECT INVOICE STATUS"  options={selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>                                  
                                <DATEPICKER_OR label="INVOICE DATE" startDate={this.state.invoiceDate} dateSelected={this.state.invoiceDate} selectedDate={(date) => this.setState({invoiceDate:date})}/>                                                      
                                <InputField label="INVOICE NUMBER" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <DATEPICKER_OR label="INVOICE APPROVE DATE" startDate={this.state.invoiceApproveDate} dateSelected={this.state.invoiceApproveDate} selectedDate={(date) => this.setState({invoiceApproveDate:date})}/>
                                <InputField label="INVOICE REMATCH DATE" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <DATEPICKER_OR label="INVOICE DUE DATE" startDate={this.state.invoiceDueDate} dateSelected={this.state.invoiceDueDate} selectedDate={(date) => this.setState({invoiceDueDate:date})}/>                                   
                                <DATEPICKER_OR label="BILLING PERIOD" startDate={this.state.billingPeriodDate} dateSelected={this.state.billingPeriodDate} selectedDate={(date) => this.setState({billingPeriodDate:date})}/>                                   
                                <InputField label="COUNTRY LEVEL" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />    
                                <DATEPICKER_OR label="INVOICE EXPECTED DATE" startDate={this.state.invoiceExpectedDate} dateSelected={this.state.invoiceExpectedDate} selectedDate={(date) => this.setState({invoiceExpectedDate:date})}/>
                                <DATEPICKER_OR label="RENTAL PERIOD" startDate={this.state.rentalPeriodDate} dateSelected={this.state.rentalPeriodDate} selectedDate={(date) => this.setState({rentalPeriodDate:date})}/>
                                <DATEPICKER_OR label="ACTUAL INVOICE MONTH" startDate={this.state.actualInvoiceMonth} dateSelected={this.state.actualInvoiceMonth   } selectedDate={(date) => this.setState({actualInvoiceMonth:date})}/>                              
                                
                                                   
                            <div>

                            </div>
                            <div></div>
                                <TabberButton label="Credit Note"/>
                            </div>
                            <div className="horizontal-separator"></div>
                            <div className="manage-invoice-detail">
                                <InputField label="RECURRING CHARGES" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="REMAINING BALANCE" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="LINE ITEMS TOTAL" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="ACCOUNT LEVEL GRADES" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="TOTAL TAXES" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="OTHER CHARGES" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="USAGE CHARGES" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="TOTAL NET" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="GROSS AMOUNT" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="MISCELLANEOUS CHARGES" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="PAYMENT" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="TOTAL AMOUNT TO PAY" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="LATER PAYMENT FEES" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="CHARGE SUBSCRIPTION" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            </div>
                            <div className="horizontal-separator"></div>
                            <div className="manage-invoice-detail">
                                <DATEPICKER_OR label="INVOICE RECEIPT DATE" startDate={this.state.invoiceReceiptDate} dateSelected={this.state.invoiceReceiptDate} selectedDate={(date) => this.setState({invoiceReceiptDate:date})}/>
                                <InputField label="INVOICE LOCAL DATE" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="INVOICE LOADED BY" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="EID NUMBER" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />                        
                                <div className="invoice-upload-container">
                                <span className="invoice-pdf-label">Invoice PDF</span>
                                    <ButtonIcon onClick={()=>alert("click")} iconLeft="cloud-arrow-up" iconSize="17px" customClassName="header-filter-button" labelName="Choose File"/> 
                                <span className="invoice-file-label">No File Selected</span>
                            </div>
                            </div>
                            <div className="horizontal-separator"></div>
                            <div className="manage-invoice-detail">
                                <InputField label="CHECK" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="AMOUNT PAID" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="PAYMENT DATE" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="AP VENDOR ID" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="REMIT ID" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <div></div>
                                <div></div>
                                <div></div>    
                                <Button className="save-button"> Save Changes </Button>                      
                            </div>
                            <div className="line-item-container">
                                    <div className="line-item-left-container">
                                        <div className="line-item-search-container">
                                            <InputGroup size="sm" className="request-input-header">              
                                                <InputGroup.Text id="inputGroup-sizing-sm">
                                                    <Icons name="search" customClassName="icon-search" size="16px" />
                                                </InputGroup.Text>
                                                <FormControl
                                                    onKeyPress={this.props.searchAction}
                                                    placeholder="Search..."
                                                    aria-label="Small"
                                                    aria-describedby="inputGroup-sizing-sm"
                                            />   
                                            </InputGroup>
                                            <ButtonIcon onClick={()=>alert("click")} iconLeft="cloud-arrow-up" iconSize="17px" customClassName="header-filter-button" labelName="UPLOAD"/> 
                                        </div>
                                        {dataTable.map((item,id)=>
                                            <DataTable getData={this.openLineItem.bind(this)} key={id} id={id} item={item} header={item.HeaderItem} isDataLoaded={true} data={item.dataItem} customClassName="table-container" />
                                        )}   
                                    </div>
                                    <div className="line-item-right-container">
                                        {tableSelected ? 
                                            <LineItem getData={this.openLineItem.bind(this)} />                                    
                                        :
                                        <div className="line-item-label-container">
                                             <div className='add-line-items-container'>
                                                <div className="add-line-label">
                                                    <div></div>
                                                    <ButtonIcon onClick={()=>alert("click")} iconLeft="file-plus" iconSize="17px" customClassName="add-line-button" labelName="Add Line Item"/> 
                                                </div>
                                                <div className="horizontal-separator"></div>
                                            </div>
                                            <div className="icon-container">
                                                <Icons name="box-light" customClassName="icon-box-light" size="48px" />
                                            </div>
                                            <span>Please select line item on the left panel or add new item</span>
                                        </div>                                    
                                        }                                  
                                    </div>
                                </div>
                        </div>
                }

                {
                    selectedIndex===Selected_Index.i_One &&
                    < InvoiceHistory dataInfo={dataInfo}/>
                }

                {
                    selectedIndex===Selected_Index.i_Two &&
                    <InvoiceComment dataInfo={this.state.commentData}/>
                }

            </ManageInvoiceLayout>
        )
    }
}